module.exports = __webpack_public_path__ + "static/img/red.3489d57.gif";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/red.gif
// module id = QeHQ
// module chunks = 1